/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TicketEventType {
    Base = '0',
    Escalation = 1,
    FollowUp = 2,
}
